module.exports = {
  key: 'en_us',
  langKey: 'EN',
  langName: 'English',
  back: "Back",
  balance: "Balance",
  payout: "Payout",
  enabled: "启用",
  disable: "禁用",
  edit: "Edit",
  save: "Save",
  delete: "Delete",
  submit: "Submit",
  cancel: "Cancel",
  prompt: "Prompt",
  status: "Status",
  pleaseEnter: "Please enter ",
  pleaseChoose: "Please choose ",
  Name: "Name",
  Phone: "Phone",
  Reco: "置顶",
  Spec: "规格",
  Hot: "热门",
  Product: {
    Title: "产品管理",
    LowestNumber: "最小购买",
    MaxNumber: "最大购买",
  },
  Order: {
    StatusList: {
      101: "等待付款",
      102: "等待商家接单",
      201: "已确认待送达",
      202: "等待骑手接单",
      203: "骑手已接单",
      204: "骑手派送中",
      300: "配送完成",
      401: "订单取消",
      402: "申请退款",
      403: "已退款",
    },
  },
  CashFlowType: {
    1: "订单收入",
    2: "运费收入",
    3: "管理费支出",
    4: "配送支出",
    5: "退款支出",
    6: "拼单返利",
    7: "提现",
    8: "GST",
    9: "管理费返还"
  },
  ShopPayoutStatus: {
    1: "审核中",
    2: "已通过",
    3: "已取消",
    4: "驳回",
  }
}